import Collection from '../collection'

class Species extends Collection{
    create(options){
        return this.axios.post(`/organizations/${this.props.currentOrganization.id}/classifications`, {
            ...options
        });
    }
    update(options){
        return this.axios.put(`/organizations/${this.props.currentOrganization.id}/classifications/${options.id}`, {
            ...options
        });
    }
    activate(options){
        return this.axios.put(`/organizations/${this.props.currentOrganization.id}/classifications/activate`, {
            ...options
        });
    }
    destroy(id){
        return this.axios.delete(`/organizations/${this.props.currentOrganization.id}/classifications/${id}`);
    }
    fetch(options = {}){
        return this.axios.get(`/organizations/${this.props.currentOrganization.id}/classifications`, {
            ...options
        });
    }
}

export default Species;